// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__eKJmz","logo":"Loader_logo__3J7_A"};